import { render, staticRenderFns } from "./Month.vue?vue&type=template&id=b88b13ea&scoped=true"
import script from "./Month.vue?vue&type=script&lang=js"
export * from "./Month.vue?vue&type=script&lang=js"
import style0 from "./Month.vue?vue&type=style&index=0&id=b88b13ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b13ea",
  null
  
)

export default component.exports